import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/gateway/beian@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-7c136418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container full-screen-container" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = {
  key: 0,
  class: "footer-logo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "footer-list flex-start" }
const _hoisted_6 = {
  key: 0,
  class: "left-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "footer-header" }, "联系我们", -1))
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "right-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "footer-header" }, "版权信息", -1))
const _hoisted_11 = { class: "footer-item" }
const _hoisted_12 = { class: "footer-item" }
const _hoisted_13 = { class: "link-text footer-item" }
const _hoisted_14 = {
  target: "_blank",
  href: "https://beian.miit.gov.cn"
}
const _hoisted_15 = {
  key: 0,
  class: "link-text footer-item"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "special-img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "footer-item flex-start" }
const _hoisted_20 = {
  key: 0,
  class: "link-text"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-line" }, "|", -1))
const _hoisted_23 = { class: "link-text" }
const _hoisted_24 = ["href"]

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'common-footer',
  setup(__props) {

const store = useStore();

// 全部备案信息
const brand = computed(() => {
    return store.state.brand && store.state.brand.publishBrand
        ? store.state.brand.publishBrand
        : {};
});

// 具体备案信息
const brandInfo = computed(() => {
    return brand.value.brandConfig ? brand.value.brandConfig : {};
});

// 底部Logo
const footerLogo = computed(() => {
    return brandInfo.value.footerLogoUrl ? brandInfo.value.footerLogoUrl : '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(footerLogo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(footerLogo),
              alt: "logo"
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_unref(brandInfo).otherFooters && _unref(brandInfo).otherFooters.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(brandInfo).otherFooters, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "footer-item",
                    key: index
                  }, _toDisplayString(item.footerName) + "：" + _toDisplayString(item.footerValue), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(brandInfo).copyright), 1),
          _createElementVNode("div", _hoisted_12, "技术支持：" + _toDisplayString(_unref(brandInfo).technicalSupport), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", _hoisted_14, _toDisplayString(_unref(brandInfo).recordNumber), 1)
          ]),
          (_unref(brandInfo).publicRecord && _unref(brandInfo).publicRecord.recordCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_unref(brandInfo).publicRecord.recordUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      target: "_blank",
                      href: _unref(brandInfo).publicRecord.recordUrl
                    }, [
                      _hoisted_17,
                      _createTextVNode(_toDisplayString(_unref(brandInfo).publicRecord.recordCode), 1)
                    ], 8, _hoisted_16))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(brandInfo).publicRecord.recordCode), 1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            (_unref(brandInfo).userAgreementWeb)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("a", {
                    href: _unref(brandInfo).userAgreementWeb
                  }, "用户协议", 8, _hoisted_21)
                ]))
              : _createCommentVNode("", true),
            (_unref(brandInfo).privacyClauseWeb)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("a", {
                      href: _unref(brandInfo).privacyClauseWeb
                    }, "隐私条款", 8, _hoisted_24)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})